import { callGetApiToServer } from "../callApi";

export async function getAllAvailableCreditsWorker(authtoken, workerId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = "v1/auth/available-credits-worker/" + workerId;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
